import React from 'react';
import styled from 'styled-components';

const TermsSmall = styled.small`
  text-align: center;
  line-height: 120%;
  font-size: 11px;
  &, & > a.terms-link {
    color: ${({ theme }) => theme.colors.gray['900']};
  }
  a.terms-link {
    text-decoration: underline;
  }
`;

const TermsCopy = () => (
  <TermsSmall>
    By clicking above, I give Upsolve and its affiliates signed consent to contact me at the number provided, either in person, by prerecorded voice message, SMS text message, or by auto dialer. Upsolve makes no representation about the quality of attorneys. I understand my consent isn’t a condition of purchase. I also agree to the <a className="terms-link" href="https://upsolve.org/terms-of-service/">Terms of Service</a>.
  </TermsSmall>
);

export default TermsCopy;